
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import { FriendListPage } from './friend-list';
import { ChatDetailsPage } from './chat-details';
import { IonicPage, ViewController, App } from 'ionic-angular';
import { ChatService } from '../../services/chat.service';
import { ImService } from "./im.service";
import { SigninPage } from '../signin/signin';
import { AlertService } from '../../providers/alert.service';
import { StorageService } from '../../providers/storage.service';
import { LoaddingService } from '../../providers/loadding.service';

@IonicPage()
@Component({
    selector: 'page-im',
    templateUrl: 'im.html',
    providers: [
        ImService
    ]
})
export class ImPage {
    parentUserName; //上级代理用户名
    unreadMessage = [];  // 未读消息数目
    sumMessage: number = 0;  //未读消息总数
    isShowList: boolean = false;
    upUser: string;     //上级
    subUser = [];    //下级
    allMessage = [];
    historyMessage = {
        username: '',
        message: '',
        data: ''
    }
    allUser: any       //上下级全部用户
    messages = [];
    perUser;
    // unreadMsgUserName;     //未读消息用户名数组
    // isShowUnreadMsg: boolean = false;  //是否显示未读消息列表
    noNewMsg: boolean;
    constructor(
        private navCtrl: NavController,
        private viewCtrl: ViewController,
        private chat: ChatService,
        private imservice: ImService,
        private alert: AlertService,
        private appCtrl: App,
        private storage: StorageService,
        private loading: LoaddingService
    ) {
        this.parentUserName = this.imservice.getParentUserName();   //获取上级
        this.upUser = this.parentUserName;
        this.perUser = this.imservice.getUserName();                //获取当前登录用户的用户名
    }
    ionViewDidLoad() {
        // 获取未读消息列表
        this.getSubUsersOrMessage();
        // 获取未读消息总数
        this.getUnreadMessageList();
    }
    ionViewDidEnter() {
        // 获取未读消息列表
        this.getSubUsersOrMessage();
        // 获取未读消息总数
        this.getUnreadMessageList();
        ImService.getMessageList = setInterval(() => {
            this.getSubUsersOrMessage();
            this.getUnreadMessageList();
        }, 5000);
    }
    ionViewDidLeave() {
        // 离开页面隐藏未读消息，进来的时候重新获取
        clearInterval(ImService.getMessageList);
    }
    /**
     * 
     * @param params 获取下级用户包含下级用户的最新消息数量，和最新消息体
     * @param messages 
     */
    getSubUsersOrMessage() {
        const params = {
            searchUserName: ''
        }
        this.chat.getSubUsersOrMessage(params).then(s => {
            if (s && s.length > 0) {
                // 将显示的表情路径更改为  [动画表情]
                s.forEach(e => {
                    e.Message = e.Message.replace(/<img (width="20px" height ="20px"){0,1} src=\"https:\/\/upimg.haozigo.com\/jquery-emoji\/img\/emoji\/[0-9]{0,}.png\" class=\"emjio-icon\">/gi, '[动画表情]');
                });
                this.allMessage = s;
                this.noNewMsg = false;
            } else {
                this.noNewMsg = true;
            }
        }).catch(err => {

        })
    }
    // 进入聊天详情页
    chatDetails(chat) {
        this.navCtrl.push(ChatDetailsPage, {
            FromUserName: chat.UserName,
        });
    }
    // 进入好友列表页
    enterFriendList() {
        this.navCtrl.push(FriendListPage);
    }
    // 获取未读消息条数
    getUnreadMessageList() {
        this.chat.getUnreadMessage().then(s => {
            if (s.length !== 0) {
                s.forEach(e => {
                    e.ChatMessageMoel.CreateTime = ImService.moment(e.ChatMessageMoel.CreateTime);
                });
                this.sumMessage = s.length;
            } else {
                this.sumMessage = 0;
            }
        }).catch(err => {
            if (err.status === 401 || err.status === 403) {
                this.alert.showAlert("验证已失效，您需要退出重新登录!");
                clearInterval(ImService.getMessageCount);
                clearInterval(ImService.getHistoryList);
                clearInterval(ImService.getMessageList);
                localStorage.clear();
                this.appCtrl.getRootNav().setRoot(SigninPage);
            }
        })
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/im/im.ts